import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from 'components/ui/use-toast';
import * as Api from '../api';
import * as Types from '../types';

const useCreate = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async (data: Types.IApi.Create.Request) => {
      const response = await Api.create(data);
      return response.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notebooks'] });
      toast.success(t('notebooks.created'), { description: t('notebooks.created_desc') });
    },
    onError: (error: any) => {
      toast.error(t('notebooks.create_failed'), { description: error?.response?.data?.message });
    },
  });
};

export default useCreate;
